import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button
} from '@chakra-ui/react';
import Form from "@rjsf/chakra-ui";
import validator from "@rjsf/validator-ajv8";
import FormLoader from '../../../../CommonComponents/FormLoader';
import CKEditorWidget from '../../../../CommonComponents/CKEditorWidget';
import { EDIT_SCHEMA, EDIT_UI_SCHEMA } from './constants';

const EditModal = ({
  isOpen,
  onClose,
  editData,
  isEditLoading,
  isEditSubmitting,
  formRef,
  setFormRef,
  onSubmit
}) => {
  const handleUpdateClick = () => {
    // Get form data from RJSF form and submit
    if (formRef && formRef.state) {
      const formData = formRef.state.formData;
      onSubmit(formData);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent maxW="90vw" maxH="90vh">
        <ModalHeader>Edit Man-Made Heritage Record</ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowY="auto">
          {isEditLoading ? (
            <FormLoader />
          ) : (
            <Form
              ref={(ref) => setFormRef(ref)}
              schema={EDIT_SCHEMA}
              uiSchema={{
                ...EDIT_UI_SCHEMA,
                preface: {
                  ...EDIT_UI_SCHEMA.preface,
                  "ui:widget": CKEditorWidget
                },
                patron: {
                  ...EDIT_UI_SCHEMA.patron,
                  "ui:widget": CKEditorWidget
                },
                background: {
                  ...EDIT_UI_SCHEMA.background,
                  "ui:widget": CKEditorWidget
                },
                structure: {
                  ...EDIT_UI_SCHEMA.structure,
                  "ui:widget": CKEditorWidget
                },
                layout: {
                  ...EDIT_UI_SCHEMA.layout,
                  "ui:widget": CKEditorWidget
                },
                materials_used: {
                  ...EDIT_UI_SCHEMA.materials_used,
                  "ui:widget": CKEditorWidget
                }
              }}
              formData={editData}
              validator={validator}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button 
            colorScheme="blue" 
            onClick={handleUpdateClick}
            isLoading={isEditSubmitting}
          >
            Update Record
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditModal;
